<template>
  <component-wrapper class="product-category">
    <grid-container-fi v-if="textsMap.KAT_POS || textsMap.BEZEICHNUNG">
      <div
        v-if="textsMap.KAT_POS"
        class="product-category__kat-pos fi-col-span-12 fi-col-start-1 sm:fi-col-span-8 sm:fi-col-start-3 lg:fi-col-span-4 lg:fi-col-start-5"
      >
        {{ textsMap.KAT_POS }}
      </div>
      <headline-fi
        v-if="textsMap.BEZEICHNUNG"
        class="product-category__name fi-col-span-12 fi-col-start-1 sm:fi-col-span-10 sm:fi-col-start-2 lg:fi-col-span-6 lg:fi-col-start-4"
        tag="h1"
        :size="60"
        :html-content="textsMap.BEZEICHNUNG"
      />
    </grid-container-fi>
    <search-fact-finder-fi
      :ref="(ref) => (search = ref)"
      class="fi-col-span-full"
      query-prefix="[category]:"
      click-source="category"
      :category-path-id-root="categoryPathIdRoot"
      :fields="fields"
      attach-breadcrumb
    >
      <template #withResults="{ searchFactFinderNg }">
        <ld-json
          v-if="searchFactFinderNg?.masters"
          :json="toLdJson(searchFactFinderNg)"
        />
      </template>
    </search-fact-finder-fi>
    <grid-container-fi
      v-if="showCategoryDescription && (textsMap.DOKBSTMETADESCRTITLE || categoryDescription)"
    >
      <div
        class="fi-col-start-1 fi-col-end-13 sm:fi-col-start-2 sm:fi-col-end-12 md:fi-col-start-3 md:fi-col-end-11 lg:fi-col-start-4 lg:fi-col-end-10"
      >
        <div class="product-category__description">
          <headline-fi
            v-if="textsMap.DOKBSTMETADESCRTITLE"
            tag="h2"
            :size="48"
            class="product-category__description__headline"
          >
            {{ textsMap.DOKBSTMETADESCRTITLE }}
          </headline-fi>

          <richtext-fi
            class="product-category__description__text"
            :html-content="{ value: categoryDescription }"
          />
        </div>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script>
import { HeadlineFi, LdJson, RichtextFi } from 'atoms';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import SearchFactFinderFi from '@/components/search-fact-finder-fi/SearchFactFinderFi.vue';
import GET_PRODUCT_CATEGORY_DATA from '@/graphql/getProductCategoryData.gql';

export default {
  name: 'ProductCategory',
  components: {
    HeadlineFi,
    GridContainerFi,
    LdJson,
    SearchFactFinderFi,
    ComponentWrapper,
    RichtextFi,
  },
  inject: ['fields'],
  data() {
    return {
      getCategoryById: {
        CategoryName: '',
        TextList: [],
      },
    };
  },
  apollo: {
    getCategoryById: {
      query: GET_PRODUCT_CATEGORY_DATA,
      variables() {
        return {
          id: this.categoryPathIdRoot,
          baseSiteId: this.$fischer.baseSiteId(),
          language: this.$fischer.catalogLocale(),
        };
      },
    },
  },
  computed: {
    categoryPathIdRoot() {
      return this.$fischer.catalogId('1001340176');
    },
    textsMap() {
      const map = {};
      this.getCategoryById.TextList.forEach((item) => {
        map[item.Key] = item.Value;
      });
      return map;
    },
    categoryDescription() {
      if (this.textsMap.SEO_DETAILS && this.textsMap.SEO_DETAILS !== '') {
        return this.textsMap.SEO_DETAILS;
      }

      return this.textsMap.DOKBSTMARKDESCR;
    },
    showCategoryDescription() {
      return !this.$fischer.isSitecoreContent();
    },
  },
  methods: {
    toLdJson({ masters }) {
      const base = `${this.$fischer.hostUrlBase()}${this.$fischer.pages.products().url}`;
      const jsonLdList = masters.hits
        .filter((item) => item.masterValuesObject.catalogCategoryData?.Slug)
        .map((item, idx) => ({
          '@type': 'ListItem',
          position: idx + 1,
          url: `${base}${item.masterValuesObject.catalogCategoryData.Slug}`,
          name: item.masterValuesObject.catalogCategoryData.CategoryName,
          image: item.masterValuesObject.catalogCategoryData.imageUrl,
        }));

      return JSON.stringify({
        '@context': 'https://schema.org/',
        '@type': 'ItemList',
        numberOfItems: masters.totalHits,
        itemListElement: jsonLdList,
      });
    },
  },
};
</script>

<style scoped src="./product-category" />
